package io.horion.cv.api.usecase

import io.horion.cv.api.datasource.common.Generate
import io.horion.cv.api.datasource.cv.Model
import io.horion.cv.api.datasource.cv.OrionCV
import io.horion.cv.api.datasource.motivation.Letter
import io.horion.cv.api.datasource.motivation.ModelLetter
import io.horion.cv.api.datasource.response.Response
import io.horion.cv.api.repository.cv.CvRepository
import io.horion.cv.api.repository.letter.LetterRepository
import io.horion.cv.api.utils.TokenRepository.apiWithTokenRetry

class CvUseCase(
    private val apiCv : CvRepository,
    private val apiLetter : LetterRepository,
) {
    suspend fun uploadImage (bytes: ByteArray?): Response? {
        if (bytes == null){
            return Response(false , "")
        }
        return apiWithTokenRetry { token ->
            apiCv.uploadImage(bytes,token)
        }
    }

    suspend fun createCv(model: Model, cv : OrionCV) : Response? {
        return apiWithTokenRetry { token ->
            apiCv.createCv(token,model, cv)
        }
    }

    suspend fun saveCv(cv : OrionCV) : Response? {
        return apiWithTokenRetry { token ->
            apiCv.saveCv(token, cv)
        }
    }

    suspend fun updateCv(cv: OrionCV, model: String? = null): Response? {
        return apiWithTokenRetry { token ->
            apiCv.updateCv(token, cv, model)
        }
    }

    suspend fun getCvList(): List<OrionCV>? {
        return apiWithTokenRetry { token ->
            apiCv.checkCvList(token)
        }
    }

    suspend fun getCvByName(name: String): OrionCV? {
        return apiWithTokenRetry { token ->
            apiCv.checkCvByName(token, name)
        }
    }

    suspend fun getCvById(id: String): OrionCV? {
        return apiWithTokenRetry { token ->
            apiCv.checkCvById(token, id)
        }
    }

    suspend fun createLetter(model: ModelLetter, letter : Letter) : Response? {
        return apiWithTokenRetry { token ->
            apiLetter.createLetter(token,model, letter)
        }
    }

    suspend fun insertLetter(letter : Letter) : Response? {
        return apiWithTokenRetry { token ->
            apiLetter.insertLetter(token,letter)
        }
    }

    suspend fun getCvHistory(refresh: Boolean = false): List<Generate>? {
        return apiWithTokenRetry { token ->
            apiCv.checkHistory(token, refresh)
        }
    }

    suspend fun deleteCv(cvId: String): Response? {
        return apiWithTokenRetry { token ->
            apiCv.deleteCv(token, cvId)
        }
    }

    suspend fun getLetterHistory(refresh: Boolean = false): List<Generate>? {
        return apiWithTokenRetry { token ->
            apiLetter.checkHistory(token, refresh)
        }
    }

    suspend fun getLetterById(id: String): Letter? {
        return apiWithTokenRetry { token ->
            apiLetter.checkLetterById(token, id)
        }
    }

    suspend fun updateLetter(letter: Letter, model: String? = null): Response? {
        return apiWithTokenRetry { token ->
            apiLetter.updateLetter(token, letter, model)
        }
    }

    suspend fun deleteLetter(letterId: String): Response? {
        return apiWithTokenRetry { token ->
            apiLetter.deleteLetter(token, letterId)
        }
    }
}